import { render } from "./MessageBar.vue?vue&type=template&id=a5e44944&scoped=true"
import script from "./MessageBar.vue?vue&type=script&lang=ts"
export * from "./MessageBar.vue?vue&type=script&lang=ts"

import "./MessageBar.vue?vue&type=style&index=0&id=a5e44944&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-a5e44944"

export default script